import React, { useState } from 'react';
import { BookOpen, BookText, Notebook, Library, FileText, GraduationCap, Gift, ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function QueIncluye() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const scrollToOffer = () => {
    const element = document.getElementById('oferta');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const blocks = [{
    title: 'KIT LENGUA Y LITERATURA – 1° AÑO',
    icon: <BookOpen className="text-blue-500 w-5 h-5 sm:w-6 sm:h-6" data-id="element-165" />,
    color: 'bg-blue-100',
    items: ['Lectura comprensiva de textos narrativos y descriptivos', 'Tipos de textos', 'Ortografía básica', 'Producción escrita: relatos breves', 'Conectores temporales', 'Vocabulario y cohesión', 'Actividades prácticas y consignas', 'Comprensión lectora', 'Producciones guiadas', 'Orientaciones pedagógicas para el docente']
  }, {
    title: 'KIT LENGUA Y LITERATURA – 2° AÑO',
    icon: <BookText className="text-green-500 w-5 h-5 sm:w-6 sm:h-6" data-id="element-166" />,
    color: 'bg-green-100',
    items: ['Narración y descripción', 'Gramática básica', 'Ortografía', 'Producción escrita', 'Comprensión lectora', 'Textos informativos', 'Actividades prácticas', 'Proyectos breves', 'Orientaciones pedagógicas']
  }, {
    title: 'KIT LENGUA Y LITERATURA – 3° AÑO',
    icon: <Notebook className="text-amber-500 w-5 h-5 sm:w-6 sm:h-6" data-id="element-167" />,
    color: 'bg-amber-100',
    items: ['Análisis de cuentos', 'Narración', 'Cohesión textual', 'Producción escrita', 'Gramática', 'Comprensión lectora', 'Actividades prácticas', 'Proyectos', 'Orientaciones pedagógicas']
  }, {
    title: 'KIT LENGUA Y LITERATURA – 4° AÑO',
    icon: <Library className="text-red-500 w-5 h-5 sm:w-6 sm:h-6" data-id="element-168" />,
    color: 'bg-red-100',
    items: ['Tipos de discurso', 'Textos narrativos y no narrativos', 'Gramática avanzada', 'Ortografía', 'Producción escrita', 'Análisis literario', 'Actividades prácticas', 'Proyectos', 'Orientaciones pedagógicas']
  }, {
    title: 'KIT LENGUA Y LITERATURA – 5° AÑO',
    icon: <FileText className="text-purple-500 w-5 h-5 sm:w-6 sm:h-6" data-id="element-169" />,
    color: 'bg-purple-100',
    items: ['Textos argumentativos', 'Comprensión lectora avanzada', 'Producción escrita', 'Gramática', 'Cohesión y coherencia', 'Discurso', 'Actividades prácticas', 'Proyectos', 'Orientaciones pedagógicas']
  }, {
    title: 'KIT LENGUA Y LITERATURA – 6° AÑO',
    icon: <GraduationCap className="text-orange-500 w-5 h-5 sm:w-6 sm:h-6" data-id="element-170" />,
    color: 'bg-orange-100',
    items: ['Análisis de textos complejos', 'Discurso social y mediático', 'Intencionalidad comunicativa', 'Producción escrita', 'Comprensión lectora', 'Cohesión textual', 'Actividades prácticas', 'Proyectos', 'Orientaciones pedagógicas']
  }, {
    title: 'BONOS INCLUIDOS',
    icon: <Gift className="text-pink-500 w-5 h-5 sm:w-6 sm:h-6" data-id="element-171" />,
    color: 'bg-pink-100',
    items: ['50 actividades adicionales', 'Planificaciones anuales por grado', 'Secuencias didácticas', 'Guía docente', 'Banco de textos', 'Antologías', 'Colección de cuentos']
  }];
  return <section id="que-incluye" className="py-5 sm:py-14 bg-white relative overflow-hidden" data-id="element-172">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-5" data-id="element-173">
        <div className="absolute top-[-10%] right-[-5%] w-96 h-96 bg-blue-600 rounded-full blur-3xl" data-id="element-174"></div>
        <div className="absolute bottom-[-10%] left-[-5%] w-96 h-96 bg-purple-600 rounded-full blur-3xl" data-id="element-175"></div>
      </div>

      <div className="max-w-4xl mx-auto px-3 sm:px-6 relative z-10" data-id="element-176">
        <div className="text-center mb-6 sm:mb-10" data-id="element-177">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-2 sm:mb-4" data-id="element-178">
            ¿Qué incluye el{' '}
            <span className="text-[#f59e0b]" data-id="element-179">
              Kit Completo Lengua y Literatura Lista
            </span>
            ?
          </h2>
        </div>

        <div className="flex flex-col gap-3 sm:gap-4 mb-8 sm:mb-12" data-id="element-180">
          {blocks.map((block, index) => {
          const isOpen = openIndex === index;
          const isBonus = index === blocks.length - 1;
          return <div key={index} className={`bg-gray-50 border border-gray-200 rounded-xl overflow-hidden transition-all duration-300 shadow-sm ${isOpen ? 'ring-2 ring-[#f59e0b] ring-opacity-50' : 'hover:border-gray-300'}`} data-id="element-181">
                <button onClick={() => toggleAccordion(index)} className="w-full flex items-center justify-between p-4 sm:p-5 text-left focus:outline-none" data-id="element-182">
                  <div className="flex items-center gap-3 sm:gap-4" data-id="element-183">
                    <div className={`${block.color} w-10 h-10 sm:w-12 sm:h-12 rounded-lg flex items-center justify-center flex-shrink-0`} data-id="element-184">
                      {block.icon}
                    </div>
                    <h3 className="text-sm sm:text-lg font-bold text-gray-900" data-id="element-185">
                      {block.title}
                    </h3>
                  </div>
                  <ChevronDown className={`w-5 h-5 text-gray-500 transition-transform duration-300 flex-shrink-0 ${isOpen ? 'transform rotate-180' : ''}`} data-id="element-186" />
                </button>

                <AnimatePresence data-id="element-187">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-188">
                      <div className="px-4 sm:px-5 pb-4 sm:pb-5 pt-0 border-t border-gray-100" data-id="element-189">
                        {isBonus ? <div className="flex flex-wrap gap-2 sm:gap-3 mt-4" data-id="element-190">
                            {block.items.map((item, i) => <span key={i} className="bg-white border border-[#fcd34d] text-gray-800 text-xs sm:text-sm px-3 py-1 rounded-full font-medium shadow-sm" data-id="element-191">
                                {item}
                              </span>)}
                          </div> : <ul className="space-y-2 mt-4" data-id="element-192">
                            {block.items.map((item, i) => <li key={i} className="text-gray-600 text-xs sm:text-sm flex items-start" data-id="element-193">
                                <span className="mr-2 text-[#f59e0b] mt-0.5" data-id="element-194">
                                  •
                                </span>
                                <span data-id="element-195">{item}</span>
                              </li>)}
                          </ul>}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        {/* Persuasion CTA */}
        <div className="text-center" data-id="element-196">
          <button onClick={scrollToOffer} className="inline-flex items-center justify-center bg-[#16a34a] hover:bg-green-700 text-white text-sm sm:text-lg font-bold py-3 sm:py-4 px-6 sm:px-8 rounded-full shadow-lg transition-all transform hover:scale-105" data-id="element-197">
            📚 ¡Quiero organizar mi año ahora!
          </button>
        </div>
      </div>
    </section>;
}